import { useState, useContext, useEffect, useRef } from 'react';
import styles from './Feedback.module.scss';
import { UserContext } from '../../globalContext/context';
import { showMsg } from '../../langs/langs';
import { getRequest } from '../../utils/apiCall';
import { Toast } from 'primereact/toast';

const   feedback_url = 'api/v1/feedback';

export default function Feedback({userId}) {
    const {lang} =useContext(UserContext);
    const toast = useRef(null);

    const [feedback, setFeedback] = useState('');

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const callFeedback = async () => {

        try {
            const response = await getRequest(`${feedback_url}/${userId}`);
            setFeedback(response.data.data);
        }
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message)
              } 
        }
    }

    useEffect(() => {
        callFeedback();
    },[]);


  return (
    <>
       <Toast ref={toast} position="top-center" />
        <div className='d-flex mb-3'>
            <div className={`${styles.feedbackBox}`}>
                <div className={`${styles.feedbackValue}`}>
                    <i className={`bi bi-emoji-smile ${styles.happy}`}></i>
                    <span className={`ps-2`}>
                        {
                            !feedback
                                ? 0
                                : feedback.positive
                        
                        }
                    </span>
                </div>
                <span className={`d-lg-none d-xl-block`}>
                    {showMsg('satisfied',lang)}
                </span>
            </div>
            <div className={`${styles.feedbackBox}`}>
                <div className={`${styles.feedbackValue}`}>
                    <i className={`bi bi-emoji-neutral ${styles.acceptable}`}></i>
                    <span className={`ps-2`}>
                        {
                            !feedback
                                ? 0
                                : feedback.neutral
                        }
                    </span>
                </div>
                <span className={`d-lg-none d-xl-block`}>
                    {showMsg('acceptable',lang)}
                </span>
            </div>
            <div className={`${styles.feedbackBox}`}>
                <div className={`${styles.feedbackValue}`}>
                    <i className={`bi bi-emoji-frown ${styles.unhappy}`}></i>
                    <span className={`ps-2`}>
                        {
                            !feedback
                            ? 0
                            : feedback.negative
                        
                        }
                    </span>
                </div>
                <span className={`d-lg-none d-xl-block`}>
                    {showMsg('negative',lang)}
                </span>
            </div>
        </div>
        <div className={`mb-3 text-center ${styles.feedbackPercent}`}>
            {showMsg('you_have',lang)} {' '}
            <span className='fw-bold'>
                {
                    !feedback
                        ? 0
                        : feedback.percent
                }%
            </span>
            {' '}{showMsg('positive_feedback',lang)}
        </div>
    </>
  )
}
